import React from 'react';

function RequestComponent() {
    return (
        <div class="cta">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-6">
                        <div class="heading1-w">
                            <h2>At M2V Consulting, We’re Committed to Business Transformation</h2>
                            <div class="space16"></div>
                            <p>Take the first step toward unlocking your business potential by reaching out today. Schedule a consultation with one of our digital strategy experts to discuss your goals and discover how our tailored solutions can accelerate your growth and innovation.</p>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="buttons">
                            <a class="cta-btn1" href="/contact_us">Request a Consultation <span><i class="fa-solid fa-arrow-right"></i></span></a>
                            <a class="cta-btn2" href="/services">Explore our Services<span><i class="fa-solid fa-arrow-right"></i></span></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RequestComponent;